export const regionOptions = ["全部", "中国", "中国香港", "美国", "日韩", "欧洲"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022", "2021"];

export const genreOptions = [
  "全部",
  "动作",
  "喜剧",
  "爱情",
  "科幻",
  "悬疑",
  "剧情",
  "古装",
  "战争",
  "青春",
  "犯罪",
  "奇幻",
  "历史",
];

export const sortOptions = [
  { key: "popular", label: "热门度" },
  { key: "newest", label: "新上架" },
  { key: "rating", label: "评分" },
];

export const categoryMeta = {
  movie: {
    title: "电影",
    subtitle: "高清电影在线观看",
    intro:
      "汇集最新院线大片、经典佳片与高分口碑之作，覆盖动作、科幻、悬疑、喜剧等多种类型，总有一部适合你。",
  },
  tv: {
    title: "电视剧",
    subtitle: "热播剧集全集在线看",
    intro:
      "从热播大剧到经典长青劇集，涵盖都市、古装、悬疑、历史等题材，支持按地区、年份与类型精准筛选。",
  },
} as const;